import { Calendar, CalendarChangeParams } from "primereact/calendar";

import Label from "../Label";

type InputCalendarPropsT = {
  id: string;
  label?: string;
  name?: string;
  value?: Date | null;
  isRequired?: boolean;
  placeholder?: string;
  onChange?: (e: { target: { name?: string; value: Date | null } }) => void;
  error?: string;
  helperText?: string;
  className?: string;
  inputClassName?: string;
  disabled?: boolean;
  minDate?: Date;
  maxDate?: Date;
  showIcon?: boolean;
  dateFormat?: string;
  readOnlyInput?: boolean;
};

const InputCalendar = ({
  id,
  label,
  name,
  value,
  isRequired,
  placeholder,
  onChange,
  error,
  helperText,
  className,
  inputClassName,
  disabled,
  minDate,
  maxDate,
  showIcon = true,
  dateFormat = "dd-MM-yy",
  readOnlyInput = true,
}: InputCalendarPropsT) => {
  const labelId = `${id}-label`;
  const errorId = `${id}-error`;
  const helperId = `${id}-helper`;
  
  const describedBy =
    [error ? errorId : null, !error && helperText ? helperId : null]
      .filter(Boolean)
      .join(" ") || undefined;

  const handleChange = (e: CalendarChangeParams) => {
    onChange?.({ target: { name, value: (e.value as Date | null) ?? null } });
  };

  return (
    <section
      aria-labelledby={label ? labelId : undefined}
      className="flex flex-col gap-1 w-full"
    >
      {!!label && (
        <div id={labelId}>
          <Label htmlFor={id} text={label} isRequired={!!isRequired} />
        </div>
      )}
      <div className={`p-inputgroup flex-1 ${className ?? ""}`.trim()}>
        <Calendar
          inputId={id}
          aria-labelledby={label ? labelId : undefined}
          aria-required={isRequired || undefined}
          aria-invalid={!!error}
          aria-describedby={describedBy}
          value={value ?? null}
          onChange={handleChange}
          dateFormat={dateFormat}
          placeholder={placeholder}
          showIcon={showIcon}
          disabled={disabled}
          minDate={minDate}
          maxDate={maxDate}
          readOnlyInput={readOnlyInput}
          locale="es"
          showButtonBar
          className={`!h-5 w-full ${error ? "p-invalid " : ""}`.trim()}
          inputClassName={`${inputClassName ?? ""}`.trim()}
        />
      </div>
      {!!helperText && !error && (
        <small id={helperId} className="-mt-1 text-gray-500">
          {helperText}
        </small>
      )}
      {!!error && (
        <small id={errorId} role="alert" className="-mt-1 text-red-500">
          {error}
        </small>
      )}
    </section>
  );
};

export default InputCalendar;